__webpack_require__.p = "/reports-manage-location-new-groups-filters/referrals-hub/";